import { Component, h, Prop, Element, type EventEmitter, Event } from '@stencil/core';

export declare type BayWaChipsVariant = 'filter' | 'single-choice' | 'multi-choice';

@Component({ tag: 'baywa-chip' })
export class BaywaChip {
  private inputElement: HTMLInputElement;

  @Element() element: HTMLBaywaChipElement;

  /**
   * The internal name
   */
  @Prop() name: string;
  /**
   * The chip label
   */
  @Prop() label: string;
  /**
   * The technical key e.g. plant_protection
   */
  @Prop() value: string;
  /**
   * The optional icon key (see Storybook => Iconography)
   */
  @Prop() icon: string;
  /**
   *  The chip type
   */
  @Prop() variant: BayWaChipsVariant = 'filter';

  /**
   * Fired when chip is about to close
   */
  @Event() chipClose: EventEmitter<void>;

  private dispatchFilterChange() {
    const event = new window.Event('change', { bubbles: true, cancelable: true });
    this.inputElement.form?.dispatchEvent(event);
  }

  private handleOnFilterClick() {
    this.inputElement.checked = false;
    this.dispatchFilterChange();
    this.chipClose.emit();
  }

  private renderIcon() {
    if (!this.icon) return '';

    return <baywa-icon icon={this.icon}></baywa-icon>;
  }

  private renderChoice() {
    const id = `${this.name}-${this.value}-id`;
    return (
      <div class="baywa-chip">
        <input name={this.name} value={this.value} id={id} type={this.variant === 'single-choice' ? 'radio' : 'checkbox'} />
        <label htmlFor={id}>
          {this.renderIcon()}
          {this.label}
        </label>
      </div>
    );
  }

  private renderFilter() {
    return (
      <div class="baywa-chip">
        <input
          type="checkbox"
          value={this.value}
          name={this.name}
          checked={true}
          ref={(ref: HTMLInputElement) => {
            this.inputElement = ref;
          }}
        />
        <button
          onClick={() => {
            this.handleOnFilterClick();
          }}
        >
          {this.label}
        </button>
      </div>
    );
  }

  render() {
    if (this.variant === 'filter') {
      return this.renderFilter();
    }
    return this.renderChoice();
  }
}
